(function () {
  var GIFT_VARIANT_ID = 67828048527633; // FREE GIFT - Chan Chan Ghungroo Bangles (Rs 0 product)
  var MIN_PAISE = 199900;               // Rs 1,999
  var originalFetch = window.fetch.bind(window);
  var running = false;

  function post(url, body) {
    return originalFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refreshIfCartPage() {
    if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
  }

  function syncGift() {
    if (running) return;
    running = true;
    originalFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = cart.items.filter(function (i) { return i.variant_id === GIFT_VARIANT_ID; })[0];
        var eligible = cart.original_total_price; // gift is Rs 0, so it never counts

        if (eligible >= MIN_PAISE && !gift) {
          return post('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }).then(refreshIfCartPage);
        }
        if (gift && (eligible < MIN_PAISE || gift.quantity > 1)) {
          var qty = eligible < MIN_PAISE ? 0 : 1;
          return post('/cart/change.js', { id: gift.key, quantity: qty }).then(refreshIfCartPage);
        }
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = originalFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(syncGift, 300); });
    }
    return p;
  };

  syncGift();
})();